<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <data-selector
          required
          :items="types"
          :value="attributeType.type"
          @input="updateType"
          :error="$root.errorBag.type"
          description="Select the type of attribute we are dealing with">
          Type
        </data-selector>
      </div>
      <div class="column is-narrow">
        <switch-input
          classes="is-large is-rounded"
          :value="attributeType.published"
          @input="togglePublished"
          :error="$root.errorBag.published"
          description="If published the attribute will be used in scans">
          Published
        </switch-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <text-input
          required
          :value="attributeType.title"
          @input="updateTitle"
          :error="$root.errorBag.title"
          description="Display name of the attribute">
          Title
        </text-input>
      </div>
      <div class="column">
        <select-input
          required
          :items="castTypes"
          :value="attributeType.cast_type"
          @input="updateCastTo"
          :error="$root.errorBag.cast_type"
          description="The data type of this attribute">
          Data Type
        </select-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <text-input
          :value="attributeType.description"
          @input="updateDescription"
          :error="$root.errorBag.description">
          Description
        </text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <text-input
          :value="attributeType.before_parser"
          @input="updateBeforeParser"
          :error="$root.errorBag.before_parser"
          description="Parses and transforms scraped data before storing it">
          Before Parser
        </text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column is-narrow">
        <switch-input
          classes="is-large is-rounded"
          :value="attributeType.can_be_vulnerable"
          @input="toggleCanBeVulnerable"
          :error="$root.errorBag.can_be_vulnerable">
          Can be Vulnerable
        </switch-input>
      </div>
      <div class="column is-narrow">
        <switch-input
          classes="is-large is-rounded"
          :value="attributeType.scrapes_on_client"
          @input="toggleClientScrape"
          :error="$root.errorBag.scrapes_on_client">
          Scrapes from Client
        </switch-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button 
          left-icon="save"
          :working="saving"
          @submit="saveAppMeta">
          Save
        </submit-button>
      </div>
      <div class="column is-narrow">
        <action-button 
          class="is-danger"
          left-icon="trash"
          @click="deleteMeta">Delete</action-button>
      </div>
    </div>
  </form>  
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    saving: false,
    castTypes: [
      {
        label: 'Boolean',
        value: 'boolean'
      },
      {
        label: 'String',
        value: 'string'
      },
      {
        label: 'Number',
        value: 'integer'
      },
      {
        label: 'Array',
        value: 'array'
      },
      {
        label: 'Object',
        value: 'object'
      },
    ]
  }),

  beforeCreate() {
    Promise.all([
      this.$store.dispatch('attributeType/loadAttributeType', this.$route.params.attributeType)
    ])
  },
  
  methods: {
    ...mapMutations('attributeType', [
      'updateTitle',
      'updateScraper',
      'updateDefaultValue',
      'updateType',
      'updateSoftwareId',
      'toggleCanBeVulnerable',
      'updateCastTo',
      'toggleClientScrape',
      'updateBeforeParser',
      'updateDescription',
      'togglePublished'
    ]),
    saveAppMeta() {
      this.saving = true
      this.$store.dispatch('attributeType/update').then(() => {
        this.saving = false
        this.$toast.success('saved')
      }).catch(error => {
        this.$toast.error('whoops')
        this.saving = false
      })
    },
    async deleteMeta() {
      if(await this.$confirm({
        title: 'Delete App Meta Attribute',
        message: 'Deleting this attribute will delete all attributes associated with it'
      })) {
        this.$store.dispatch('attributeType/deleteAppMeta', this.attributeType.id).then(() => {
          this.$toast.success('deleted')
          this.$router.push({
            name: 'attribute-types'
          })
        }).catch(error => {
          this.$toast.error('whoops')
        })
      }
    }
  },

  computed: {
    ...mapGetters('attributeType', [
      'attributeType',
      'types'
    ]),
    ...mapGetters('software', [
      'softwareList'
    ]),
    needsShortName() {
      return this.attributeType.type === 'environment' || this.attributeType.type === 'config'
    }
  }
  
}
</script>